import * as React from "react";
import { SVGProps } from "react";


const PrismLogo = (props: SVGProps<SVGSVGElement>) => (
        <svg
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 471.14 98.6"
            width={220}
            height={52}
            {...props}
        >
          <g>
            <path fill="#fff" fillRule="evenodd"
                  d="M81.2,48.57c1.4-1.7,2.1-3.9,2-6.1.1-2.8-1.1-5.5-3.2-7.3-1.9-1.7-5.1-2.5-9.6-2.5h-5.9v34.3h5v-14.6h.8l7.9,14.8h5.9l-8.3-15.3c2.1-.4,4-1.6,5.4-3.3ZM69.5,47.87v-10.7h1.8c4.6,0,7,1.7,7,5.2,0,3.7-2.4,5.5-7.2,5.5h-1.6Z" />
            <path fill="#fff" fillRule="evenodd"
                  d="M112.4,32.47c-4.6-.1-9.1,1.8-12.4,5.1-3.3,3.1-5.2,7.5-5.2,12.1-.2,5,1.9,9.8,5.7,13.1,6.9,6.2,17.5,5.9,24.1-.6,3.4-3.2,5.2-7.6,5.1-12.3.1-4.6-1.8-9.1-5.1-12.3-3.1-3.3-7.6-5.1-12.2-5.1ZM121.1,58.77c-2.4,2.4-5.7,3.7-9,3.6-6-.2-10.9-4.5-11.9-10.2l-.2-2.5.2-2.4c.4-2.4,1.6-4.7,3.4-6.4,2.4-2.4,5.7-3.7,9.1-3.7,6.8.2,12.2,5.8,12,12.6.1,3.4-1.2,6.6-3.6,9Z" />
            <rect fill="#fff" x="46.4" y="32.47" width="5" height="34.6" />
            <path fill="#fff" fillRule="evenodd"
                  d="M199.4,31.37l-16.6,35.7h5.5l3.8-8.3h14.3l3.5,8.3h5.5l-16-35.7ZM194.1,53.97l5.2-11.4,5,11.4h-10.2Z" />
            <polygon fill="#fff" fillRule="evenodd"
                     points="16.9 55.87 5.7 32.37 .2 32.37 16.8 66.57 28.5 41.97 28.5 67.17 33.9 67.17 33.9 32.27 28.2 32.27 16.9 55.87" />
            <path fill="#fff" fillRule="evenodd"
                  d="M3.5,60.07c-1.9-.1-3.4,1.4-3.5,3.2-.1,1.9,1.4,3.4,3.2,3.5,1.9.1,3.5-1.4,3.5-3.2.1-1.8-1.3-3.4-3.2-3.5Z" />
            <path fill="#fff" fillRule="evenodd" d="M141.6,60.07c-1.9,0-3.4,1.5-3.4,3.4s1.5,3.4,3.4,3.4,3.4-1.5,3.4-3.4-1.5-3.4-3.4-3.4Z" />
            <polygon fill="#fff" fillRule="evenodd"
                     points="155.1 55.87 143.9 32.37 138.4 32.37 155 66.57 166.7 41.97 166.7 67.17 172.1 67.17 172.1 32.37 166.3 32.37 155.1 55.87" />
          </g>
          <g>
            <path fill="#fff" d="M306.24,32.93c-10.92,0-21.84,0-32.76,0V0s32.5,32.38,32.5,32.38c.19.14.19.35.26.54Z" />
            <path fill="#fff"
                  d="M273.48,32.93l-32.58,32.75h32.67l32.67-32.75c.05.15.28.33.19.61v32.32h-33.04l-32.85,32.75V32.93c10.98,0,21.96,0,32.94,0Z" />
          </g>
          <g>
            <path fill="#fff" fillRule="evenodd"
                  d="M347.21,34.42c-2.56-2.21-5.77-2.52-8.86-2.52h-6.75v34.75h5.1v-14.5h2.55c8.29,0,11.25-5.19,11.25-10.05,0-1.81-.43-5.22-3.29-7.68ZM345.4,41.9c0,3.4-2.31,5.35-6.35,5.35h-2.35v-10.45h2.05c4.41,0,6.65,1.72,6.65,5.1Z" />
            <path fill="#fff" fillRule="evenodd"
                  d="M378.35,41.85c0-3.34-1.48-6.33-3.96-7.98-2.57-1.75-5.89-1.97-8.49-1.97h-6.05v34.75h5.1v-14.43l10.04,14.43h6.22l-10.71-15.05c4.74-.84,7.85-4.63,7.85-9.75ZM373.25,41.95c0,4.7-4.17,5.4-6.65,5.4h-1.65v-10.55h1.55c1.42,0,3.06.07,4.45.86,1.57.9,2.3,2.26,2.3,4.29Z" />
            <rect fill="#fff" x="390.4" y="31.9" width="5.1" height="34.75" />
            <path fill="#fff" fillRule="evenodd"
                  d="M420.68,46.46l-3.21-1.4c-1.22-.54-2.38-1.05-3.29-1.97-.78-.74-1.03-1.32-1.03-2.39,0-2.66,1.97-4.45,4.9-4.45,1.67,0,2.73.55,3.31,1,.64.51,1.33,1.4,1.76,2.27l.35.71,4.13-2.73-.29-.56c-.83-1.61-2.07-3.02-3.48-3.96-1.68-1.12-3.45-1.62-5.74-1.62-5.92,0-10.05,3.83-10.05,9.3,0,2.47.75,4.25,2.51,5.95,1.48,1.43,3.08,2.17,4.37,2.76l3.28,1.53c1.64.75,2.93,1.34,3.82,2.18.97.89,1.42,1.96,1.42,3.38,0,2.94-1.86,5.9-6,5.9-1.84,0-3.17-.51-4.29-1.63-.94-.99-1.61-2.4-1.81-3.87l-.11-.79-5.01,1.39.15.65c.56,2.48,1.76,4.76,3.29,6.25,1.99,1.95,4.53,2.9,7.74,2.9,6.52,0,11.25-4.61,11.25-10.95,0-2.69-.83-4.77-2.61-6.55-1.41-1.41-3.16-2.34-5.37-3.3Z" />
            <path fill="#fff" fillRule="evenodd" d="M440.64,59.33c-1.9,0-3.4,1.5-3.4,3.4s1.5,3.4,3.4,3.4,3.4-1.5,3.4-3.4-1.5-3.4-3.4-3.4Z" />
            <polygon fill="#fff" fillRule="evenodd"
                     points="465.34 31.63 454.14 55.13 442.94 31.63 437.44 31.63 454.04 65.83 465.74 41.23 465.74 66.43 471.14 66.43 471.14 31.63 465.34 31.63" />
          </g>
        </svg>
    )
;


export default PrismLogo

